export const validationErrors = {
	InvalidField: 'This field is invalid',
};
